export default "__VITE_ASSET__D0uZcNez__"